import { render, staticRenderFns } from "./ListUserReadOnly.vue?vue&type=template&id=aab9170c&scoped=true&"
import script from "./ListUserReadOnly.vue?vue&type=script&lang=js&"
export * from "./ListUserReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ListUserReadOnly.vue?vue&type=style&index=0&id=aab9170c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab9170c",
  null
  
)

export default component.exports